var App = App || {};

App.FloatingButtons = (function ($) {
    "use strict";

    var $chatButton;

    function init() {
        $chatButton = $("#chatBtn");
        $chatButton.on("click", function (e) {
            $(".LPMimage").click();
            e.preventDefault();
        });
    }

    return {
        init: init
    }
})(jQuery);

$(function () {
    App.FloatingButtons.init();
});